"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.storeShape = exports.subscriptionShape = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var subscriptionShape = _propTypes.default.shape({
  trySubscribe: _propTypes.default.func.isRequired,
  tryUnsubscribe: _propTypes.default.func.isRequired,
  notifyNestedSubs: _propTypes.default.func.isRequired,
  isSubscribed: _propTypes.default.func.isRequired
});

exports.subscriptionShape = subscriptionShape;

var storeShape = _propTypes.default.shape({
  subscribe: _propTypes.default.func.isRequired,
  dispatch: _propTypes.default.func.isRequired,
  getState: _propTypes.default.func.isRequired
});

exports.storeShape = storeShape;


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/lib/utils/PropTypes.js
// module id = 476
// module chunks = 0